import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { isMobileOnly, isTablet } from 'react-device-detect';
import LoginPage from '../components/LoginPage/LoginPage';
import CreateUserContainer from '../containers/CreateUserContainer/CreateUserContainer';
import PasswordForgotten from '../components/PasswordForgotten/PasswordForgotten';
import PasswordRecovery from '../components/PasswordRecovery/PasswordRecovery';
import { ApplicationsList } from '../components/ApplicationsList/ApplicationsList';
import { ApplicationContainer } from '../containers/ApplicationContainer/ApplicationContainer';
import { CreateApplicationContainer } from '../containers/CreateApplicationContainer/CreateApplicationContainer';
import FilesContainer from '../containers/FilesContainer/FilesContainer';
import NewWardContainer from '../containers/NewWardContainer/NewWardContainer';
import MapContainer from '../containers/MapContainer/MapContainer';
import FileCardContainer from '../containers/FileCardContainer/FileCardContainer';
import FileMainContainer from '../containers/FileMainContainer/FileMainContainer';
import FileCommentsContainer from '../containers/FileCommentsContainer/FileCommentsContainer';
import FileProjectsContainer from '../containers/FileProjectsContainer/FileProjectsContainer';
import FileHistoryContainer from '../containers/FileHistoryContainer/FileHistoryContainer';
import { useAppSelector } from '../store/hooks';
import UserProfileContainer from '../containers/UserProfileContainer/UserProfileContainer';
import { InfoContainer } from '../containers/InfoContainer/InfoContainer';
import NotificationsContainer from '../containers/NotificationsContainer/NotificationsContainer';
import AdministrationContainer from '../containers/AdministrationContainer/AdministrationContainer';
import usePermissions from '../lib/utils/usePermissions';
import { HasNotPermissions } from '../components/HasNotPermission/HasNotPermissions';
import { PERSONLIST_READ, PERSONLIST_READ_ALLREGIONS, PERSON_CREATE } from '../lib/const/permissions';
import EmailConfirmationContainer from '../containers/EmailConfirmationContainer/EmailConfirmationContainer';
import ForcePasswordChange from '../components/ForcePasswordChange/ForcePasswordChange';
import LoginPageMobile from '../components/LoginPageMobile/LoginPageMobile';
import { FormInstance } from 'antd/lib/form';

interface Props {
  isAuth: boolean;
  isResetPassword?: boolean;
  //setCreateAgreementModalVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}

function AppRoutes(props: Props) {
  const { meUserFull } = useAppSelector((state) => state.persons);
  const isUserNewVolunteer = meUserFull?.personStatusId === 1 && meUserFull?.personTypeId === 3;
  const isSchoolOfVolunteer = meUserFull?.personStatusId === 2;

  const [hasAccess] = usePermissions();

  // Если требуется принудительная смена пароля
  if (props.isResetPassword) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="force_password_change" />} />
        <Route path="force_password_change" element={<ForcePasswordChange />} />
        <Route path="password-forgotten" element={<PasswordForgotten />} />
        <Route path="change_password" element={<PasswordRecovery />} />
      </Routes>
    );
  }

  if (props.isAuth) {
    if (isMobileOnly || isTablet) {
      return (
        <Routes>
          <Route path="*" element={<LoginPageMobile />} />
          <Route path="email-confirmation" element={<EmailConfirmationContainer />} />
          <Route path="change_password" element={<PasswordRecovery />} />
        </Routes>
      );
    } else {
      return (
        <Routes>
          <Route path="*" element={<Navigate to="applications/map" />} />
          <Route path="applications">
            <Route path="" element={<Navigate to="list" />} />
            <Route path="list">
              <Route path="" element={<ApplicationsList />} />
              <Route path=":applicationId/*" element={<ApplicationContainer />} />
            </Route>
            <Route path="map" element={<MapContainer />} />
            <Route path="create-application" element={<CreateApplicationContainer />} />
            <Route path="create-application/:applicationId" element={<CreateApplicationContainer />} />
          </Route>
          <Route path="files">
            <Route path="" element={<Navigate to="list" />} />
            <Route
              path="list"
              element={
                hasAccess([PERSONLIST_READ, PERSONLIST_READ_ALLREGIONS]) ? <FilesContainer /> : <HasNotPermissions />
              }
            />
            <Route path=":fileId" element={<FileMainContainer />}>
              <Route path="general" element={<FileCardContainer />} />
              <Route path="comments" element={<FileCommentsContainer />} />
              <Route path="projects" element={<FileProjectsContainer />} />
              <Route path="history" element={<FileHistoryContainer />} />
            </Route>
            <Route
              path="new-ward"
              element={hasAccess([PERSON_CREATE]) ? <NewWardContainer /> : <HasNotPermissions />}
            />{' '}
          </Route>
          {isUserNewVolunteer || isSchoolOfVolunteer ? null : (
            <Route path="administration/*" element={<AdministrationContainer />} />
          )}
          <Route path="profile/*" element={<UserProfileContainer />} />
          <Route path="notifications/*" element={<NotificationsContainer />} />
          <Route path="info/*" element={<InfoContainer />} />
          <Route path="email-confirmation" element={<EmailConfirmationContainer />} />
        </Routes>
      );
    }
  }

  return (
    <Routes>
      <Route path="*" element={<Navigate to="login" />} />
      <Route path="login" element={isMobileOnly || isTablet ? <LoginPageMobile /> : <LoginPage />} />
      <Route path="create-user" element={<CreateUserContainer />} />
      <Route path="password-forgotten" element={<PasswordForgotten />} />
      <Route path="change_password" element={<PasswordRecovery />} />
      <Route path="email-confirmation" element={<EmailConfirmationContainer />} />
    </Routes>
  );
}

export default AppRoutes;
